module.exports = __webpack_public_path__ + "img/appmas.83836c95.png";